/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：527
 */

module.exports = {
  resourceLayout: "style_resourceLayout__1NSyP",
  header: "style_header__3b4qF",
  title: "style_title__2_5F1",
  closeBtn: "style_closeBtn__HAZpy",
  tab: "style_tab__2Kp-x",
  selected: "style_selected__2xBGc",
  openMallBtn: "style_openMallBtn__3SxHu",
  rotate: "style_rotate__3hT8r",
  body: "style_body__2rOfc",
  readonly: "style_readonly__kCdeZ"
}
